import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@rbx/ui';
import CodeBlock from '@modules/ui/codeBlock/CodeBlock';
import { useTranslation } from '@rbx/intl';
import type { OpenCloudAPICodeSample } from '../../../utils/oasTypes';
import useCodeSampleContainerStyles from './CodeSampleContainer.styles';

interface CodeSampleContainerProps {
  codeSamples: OpenCloudAPICodeSample[];
}

const CodeSampleContainer: FunctionComponent<React.PropsWithChildren<CodeSampleContainerProps>> = ({
  codeSamples,
}) => {
  const { translate } = useTranslation();
  const {
    classes: { title, codeBlock },
  } = useCodeSampleContainerStyles();

  const getSampleLanguage = (language: string) => {
    if (language === 'curl') {
      return 'bash';
    }
    return language;
  };

  return (
    <Grid container direction='column'>
      <Grid item XSmall className={title}>
        <Typography variant='h4' component='h4'>
          {translate('Label.Request')}
        </Typography>
      </Grid>
      <Grid item XSmall className={codeBlock}>
        {codeSamples.map((codeSample) => (
          <CodeBlock
            key={codeSample.language}
            language={getSampleLanguage(codeSample.language)}
            content={codeSample.script.trim()}
            enableCopy
            enableExpand
            fullWidth
            title={codeSample.language}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default CodeSampleContainer;
